class HeaderMenu {
    constructor(el,opt){
      this.el = el;
      this.event();
    }
    event(){
      $(document).ready(function () {
        function toggleMegaMenu() {
          if ($(window).width() <= 767) {
            $('.mega-menu-trigger').off('click').on('click', function () {
              $('.js-plus').toggleClass('is-active');
              $('.mega-nenu').slideToggle();
            });
            $('.js-sp-menu a').click(function () {
              $('.js-drawer').removeClass('is-active');
              $('.js-sp-menu').removeClass('is-active');
      
              var menuTextElement = $('.js-menu-text');
              var menuText = menuTextElement.text();
              menuTextElement.text('MENU');
      
              fixedBody(); 
            });
          }
        }
    
        toggleMegaMenu();
    
        $(window).resize(function () {
          toggleMegaMenu();
        });
      });
      
      $('.js-drawer').click(function () {
        $('.js-drawer').toggleClass('is-active');
        $('.js-sp-menu').toggleClass('is-active');
        $('.js-sp-head').toggleClass('is-active');
        // js-menu-textのテキストをMENUであれば「閉じる」閉じるであれば「MENU」
        var menuTextElement = $('.js-menu-text');
        var menuText = menuTextElement.text();
        
        if (menuText === 'MENU') {
          menuTextElement.text('閉じる');
        } else if (menuText === '閉じる') {
          menuTextElement.text('MENU');
        }
        fixedBody();
      });
  
      $('.js-overlay').click(function () {
        if($('html').hasClass('is-open')){
          $('html').removeClass('is-open');
          $('body').removeClass('fixed').css({'top': 0});
          window.scrollTo(0, pos);
          status = false;
          $('.js-drawer, .js-head,.js-sp-menu ,.js-overlay').removeClass('is-active');
          $('.js-sp-menu').fadeToggle();
        }
      });
      
      const body = $('body');
      let status = false;
      let pos = 0;
    
      function fixedBody() {
        if (!status) {
          pos =
            window.scrollY ||
            window.scrollTop ||
            document.getElementsByTagName('html')[0]?.scrollTop ||
            0;
    
          body.addClass('fixed');
          $('body').css('top', -pos + 'px');
          status = true;
        } else {
          body.removeClass('fixed');
          $('body').css('top', '0');
          window.scrollTo(0, pos);
          status = false;
        }
      }
      
      $('.mega-menu-trigger').on('click', function() {
        $(this).toggleClass('open');
      });
    }
  }
